import { useQuery } from "@tanstack/react-query";
import { getProductCategories } from "@/services/pricing-config.service";

export const useProductCategories = (
  enabled = true,
  params = {},
  options = {},
) => {
  return useQuery({
    queryKey: ["product-categories", params.page, params.size, params.search],
    queryFn: () => getProductCategories(params),
    enabled,
    ...options,
  });
};
